module.exports = __webpack_public_path__ + "img/card-small-b4.71ce5fdd.png";